import { CookieService } from 'ngx-cookie-service'
import { NgxGfmoneyLibModule } from '@yuri.karkhachev/ngx-gfmoney-lib'
import { provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask'
import { NgxCaptchaModule } from 'ngx-captcha'
import { ModalModule } from 'ngx-bootstrap/modal'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { CurrencyPipe, DatePipe } from '@angular/common'
import { provideTranslateService } from '@ngx-translate/core'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { ApiInterceptor } from '@shared/services/api.interceptor'
import { environment } from '@environments/environment'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
  isDevMode,
} from '@angular/core'
import * as Sentry from '@sentry/angular'
import { defineLocale } from 'ngx-bootstrap/chronos'
import { daLocale } from 'ngx-bootstrap/locale'
import { registerLocaleData } from '@angular/common'
import localeDa from '@angular/common/locales/da'
import { CustomerNavigationService } from '@shared/services/customer-navigation.service'
import { provideRouter, Router, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router'
import { routes } from '@src/app/app.routes'
import { NgxGfmoneyMessagesModule } from '@yuri.karkhachev/ngx-gfmoney-messages'
import { ErrorHandlerService } from '@shared/services/error-handler.service'
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withNoIncrementalHydration,
} from '@angular/platform-browser'
import { errorLogInterceptor } from '@shared/services/error-log.interceptor'
import { provideServiceWorker } from '@angular/service-worker'
registerLocaleData(localeDa, 'da')
defineLocale('da', daLocale)

export const appConfig: ApplicationConfig = {
  providers: [
    CustomerNavigationService,
    CurrencyPipe,
    DatePipe,
    CookieService,
    importProvidersFrom(
      BsDatepickerModule,
      ModalModule,
      NgxCaptchaModule,
      NgxGfmoneyLibModule.forRoot({ servicesUrl: environment.servicesApiHost }),
      NgxGfmoneyMessagesModule.forRoot({
        allowedFileTypes: 'image/jpeg,image/png,.pdf,.txt',
        apiUrl: `${environment.apiHost}`,
        brand: environment.companyName,
        dateFormat: 'yyyy-MM-dd HH:mm',
        homePagePath: '/dashboard-visa',
      }),
      TooltipModule,
    ),
    { provide: LOCALE_ID, useValue: 'da' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'kr' },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideNgxMask(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'da',
      lang: 'da',
    }),
    provideHttpClient(withInterceptorsFromDi(), withFetch(), withInterceptors([errorLogInterceptor])),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler(navigationError => {
        const error = navigationError.error
        const errorHandler = inject(ErrorHandler)
        errorHandler.handleError(error)
      }),
    ),
    provideEnvironmentNgxMask(),
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: false,
      }),
      withNoIncrementalHydration(),
    ),
    provideAppInitializer(() => {
      inject(Sentry.TraceService)
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}
